import { useQueryString } from "hooks/useQueryString";
import AuthApiClient from "api/AuthApiClient";
import styles from "./SsoLoginError.module.styl";
import { Button } from "uikit/components";
import React from "react";

export const SsoLoginError = () => {
    const { sourceUrl } = useQueryString();
    const handleRetry = async () => {
        window.location.href = AuthApiClient.buildChallengeUrl(sourceUrl);
    };

    return (
        <div className={styles.text}>
            <p>В данный момент запрос не может быть обработан. Возможно, ваша сессия устарела.</p>
            <p>Попробуйте авторизоваться позже. Приносим извинения за неудобства.</p>
            <Button type="submit" testName="retry-button" onClick={handleRetry}>
                Войти
            </Button>
        </div>
    );
};
